// extracted by mini-css-extract-plugin
export default {"item":"Item_item__sTUfe","item__icon":"Item_item__icon__+3FBQ","item__content":"Item_item__content__VZLak"};